import { Pages } from "./types";

export const enum AnalyticsPageFlows {
  FlowsProjectRoles = "FlowsProjectRoles",
}

const flows = "Flows";

export const pagesFlows: Pages<AnalyticsPageFlows> = {
  [AnalyticsPageFlows.FlowsProjectRoles]: [flows, "Project", "Roles"],
};
